// extracted by mini-css-extract-plugin
export default {"container":"wEklTV","nameContainer":"Hi2_QZ","image":"x0jzL0","name":"wE99YP","quote":"HIR_DE"};